<template>
	<div class="relative" :class="props.context.classes.inner">
		<button
			:id="context.id"
			ref="selectboxButton"
			type="button"
			class="bg-background-primary text-base border-b border-border-tertiary py-3 px-4 text-body-primary flex justify-between items-center w-full truncate"
			:class="props.context.classes.input"
			:aria-expanded="isDropdownOpen"
			@click="isDropdownOpen = !isDropdownOpen"
		>
			<span>
				{{ props.context.attrs.labelSelect || props.context.attrs['label-select'] || 'Vyberte si' }}
			</span>
			<NuxtIcon
				name="chevron-right"
				class="text-2xl text-icon-tertiary transition"
				:class="{'rotate-90': isDropdownOpen}"
				filled
			/>
		</button>
		<ul
			v-show="isDropdownOpen"
			ref="selectboxDropdown"
			class="bg-background-primary py-3 px-8 min-w-full space-y-4 border-b border-border-tertiary"
		>
			<li
				v-if="props.context.multiple"
				key="__allOption"
				class="cursor-pointer flex items-center select-none hover:text-body-important"
				@click="toggleAll()"
			>
				<SelectboxOptionCheckbox :checked="areAllOptionsSelected" class="shrink-0" />
				{{ props.context.allOptionsLabel || 'Všechny možnosti' }}
			</li>
			<li
				v-for="(option, i) in props.context.options"
				:key="i"
				class="relative flex items-center"
				:class="[isSelected(props, option) ? 'font-semibold hover:text-body-important' : 'cursor-pointer']"
			>
				<input
					:id="getInputId(props, option)"
					:type="props.context.multiple ? 'checkbox' : 'radio'"
					:name="props.context.name"
					:value="option"
					:checked="isSelected(props, option)"
					class="hidden"
					@change="toggleOption(option, $event)"
				/>
				<SelectboxOptionCheckbox v-if="props.context.multiple" :checked="isSelected(props, option)" class="shrink-0" />
				<label :for="getInputId(props, option)" class="cursor-pointer before:cover-parent">
					{{ option.label }}
				</label>
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
	import {map, without} from 'lodash-es';
	import {getInputId, isSelected} from '~/utils/formkitSelectbox';
	import type {Option, SelectboxContext} from '@/types/formkitSelectbox';

	interface Props {
		context: SelectboxContext
	}

	const props = defineProps<Props>();

	const isDropdownOpen = ref(false);

	const areAllOptionsSelected = computed(() => {
		if (!props.context.multiple || !props.context.options) {
			return false;
		}

		const valueLength = props.context._value?.length ?? 0;
		return valueLength >= props.context.options.length;
	});

	function toggleOption(option: Option, state: Event) {
		if (props.context.multiple) {
			const newValue = (state.target as HTMLInputElement).checked
				? [...props.context._value, option.value]
				: without(props.context._value, option.value);

			props.context.node.input(newValue);
		} else {
			props.context.node.input(option.value);
		}

		if (!props.context.multiple) {
			isDropdownOpen.value = false;
		}
	}

	function toggleAll() {
		props.context.node.input(
			areAllOptionsSelected.value
				? []
				: map(props.context.options, 'value'),
		);
	}
</script>
